import * as React from "react";
import Link from "gatsby-link";
import styled, { keyframes, css } from "styled-components";
import { em } from "polished";

import media from "../helpers/mediaqueries";
import ArrowIcon, { Direction } from "./ArrowIcon";
import { ThemeContextConsumer } from "../context/ThemeContext";

export const enum SideNavigationTheme {
  DARK = "transparent",
  LIGHT = "#f2f2f2"
}

interface WrapperProps {
  theme: SideNavigationTheme;
}

const Wrapper = styled.aside`
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  width: 50px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  background-color: ${(props: WrapperProps) => props.theme};
  z-index: 9999;

  ${media.phone`
    display: none;
  `};
`;

const Button = styled.button`
  width: 100%;
  height: 50%;
  border: 0;
  border-right: 1px solid rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease-out;
  cursor: pointer;

  &:hover {
    color: #fff;
    background-color: #9f2e7e;
    border-color: #9f2e7e;
  }
`;

const SingleButton = Button.extend`
  height: 100%;
  border-right: 1px solid rgba(255, 255, 255, 0.1);
  color: rgba(255, 255, 255, 0.4);
  background-color: transparent;
`;

const Text = styled.div`
  margin-left: 50%;
  display: inline-block;
  transform: translate(-50%) rotate(-90deg);
  font-size: ${em("13px")};
  font-family: "ahamonoregular", sans-serif;
  white-space: nowrap;
  transition: 0.3s opacity;

  .wf-loading & {
    opacity: 0;
  }

  .wf-active & {
    opacity: 1;
  }
`;

const UpDownAnimation = keyframes`
  0% {
      transform: translate(0, -10px);
      opacity: 0;
  }
  50% {
      opacity: 1;
  }
  100% {
      transform: translate(0, 10px);
      opacity: 0;
  }
`;

const AnimatedArrow = styled.div`
  position: absolute;
  bottom: 20px;
  left: 0;
  right: 0;
  margin: auto;
  animation: ${UpDownAnimation} 1.5s ease-in-out infinite;
`;

interface ButtonProps {
  transparent: boolean;
  single: boolean;
  text: string;
  prev: string;
  next: string;
}

const SideNavigationButton: React.SFC<ButtonProps> = props => {
  if (props.single) {
    return (
      <SingleButton>
        <Text>{props.text}</Text>
        <AnimatedArrow>
          <ArrowIcon direction={Direction.BOTTOM} />
        </AnimatedArrow>
      </SingleButton>
    );
  } else {
    return (
      <React.Fragment>
        <Button>
          <Text>{props.prev}</Text>
        </Button>
        <Button>
          <Text>{props.next}</Text>
        </Button>
      </React.Fragment>
    );
  }
};

interface Props {
  options: ButtonProps;
}

const SideNavigation: React.SFC<Props> = props => {
  return (
    <ThemeContextConsumer>
      {({ sideNavigation }) => (
        <Wrapper theme={sideNavigation}>
          {SideNavigationButton(props.options)}
        </Wrapper>
      )}
    </ThemeContextConsumer>
  );
};

export default SideNavigation;



// WEBPACK FOOTER //
// ./src/components/SideNavigation.tsx